
    import {useStore} from "@/store";
    import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";

    interface State {
        dataList: object[];
    }

    export default defineComponent({
        name: "ConfigInfo",
        setup() {
            let state: State = reactive({
                dataList: [],
            })
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {configureInfos} = data;
                state.dataList = configureInfos;
            })
            return {
                state
            }
        },
    })
